import { c as _c } from "react/compiler-runtime";
/* eslint-disable local-rules/require-use-client */
import { Radio } from '@headlessui/react';
import { useEffect, useState } from 'react';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
import { SKUSelectorV2Dropdown } from './SKUSelectorV2Dropdown';
import type { SKUSelectorV2RadioOption } from './SKUSelectorV2Props';
export interface SKUSelectorV2RadioProps {
  option: SKUSelectorV2RadioOption;
  selectedSku: string;
  isLoading: boolean;
  previewAllItems: boolean;
  onChange: (sku: string) => void;
}
export function SKUSelectorV2Radio(t0) {
  const $ = _c(36);
  const {
    option,
    selectedSku,
    previewAllItems,
    isLoading,
    onChange
  } = t0;
  const {
    dropdownOptions
  } = option;
  const [activeDropdownOption, setActiveDropdownOption] = useState(dropdownOptions?.[0]);
  let t1;
  let t2;
  if ($[0] !== dropdownOptions || $[1] !== selectedSku) {
    t1 = () => {
      setActiveDropdownOption(current => dropdownOptions?.find(option_0 => option_0.sku === selectedSku) ?? current);
    };
    t2 = [dropdownOptions, selectedSku];
    $[0] = dropdownOptions;
    $[1] = selectedSku;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const activeOption = option.isDropdown ? activeDropdownOption : option;
  const isSelected = selectedSku === activeOption?.sku;
  let t3;
  if ($[4] !== previewAllItems) {
    t3 = previewAllItems && getBuilderPreviewMode().edit;
    $[4] = previewAllItems;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const isPreview = t3;
  const t4 = activeOption?.sku;
  const t5 = isSelected && "outline-2 outline-bodi-black-text";
  let t6;
  if ($[6] !== t5) {
    t6 = cn(["flex shrink-0 flex-col gap-3 rounded-lg p-4 outline outline-1 outline-bodi-gray-butters hover:outline-bodi-black-text lg:p-6", t5]);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isSelected && "bg-transparent outline-bodi-accent-deep-500";
  let t8;
  if ($[8] !== t7) {
    t8 = cn("flex size-[22px] items-center justify-center rounded-full bg-bodi-gray-pearl outline outline-2 outline-bodi-gray-butters", t7);
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = isSelected && "bg-bodi-input-selected";
  let t10;
  if ($[10] !== t9) {
    t10 = cn("size-3 rounded-full bg-transparent", t9);
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10) {
    t11 = <div className={t10} />;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t8) {
    t12 = <div className={t8}>{t11}</div>;
    $[14] = t11;
    $[15] = t8;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== activeDropdownOption || $[18] !== activeOption?.content || $[19] !== isLoading || $[20] !== isPreview || $[21] !== onChange || $[22] !== option.dropdownOptions || $[23] !== option.isDropdown || $[24] !== selectedSku) {
    t13 = option.isDropdown ? <SKUSelectorV2Dropdown dropdownOptions={option.dropdownOptions} activeOption={activeDropdownOption} selectedSku={selectedSku} isLoading={isLoading} onChange={onChange} previewAllItems={isPreview} /> : <div className="flex-1">{activeOption?.content}</div>;
    $[17] = activeDropdownOption;
    $[18] = activeOption?.content;
    $[19] = isLoading;
    $[20] = isPreview;
    $[21] = onChange;
    $[22] = option.dropdownOptions;
    $[23] = option.isDropdown;
    $[24] = selectedSku;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13) {
    t14 = <div className="flex w-full shrink-0 gap-3">{t12}{t13}</div>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14 || $[30] !== t6) {
    t15 = <div className={t6}>{t14}</div>;
    $[29] = t14;
    $[30] = t6;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== isLoading || $[33] !== t15 || $[34] !== t4) {
    t16 = <Radio className="rounded-lg outline-bodi-black-text" value={t4} disabled={isLoading}>{t15}</Radio>;
    $[32] = isLoading;
    $[33] = t15;
    $[34] = t4;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
}